import { Country } from "../../../api/types/constants";

interface SplitNumberReturnValue {
  prefix: string;
  number: number | null;
}

export const splitNumber = (countries: Country[], phone: string): SplitNumberReturnValue => {
  let countryPrefix = countries.find((country) => phone.startsWith(country.prefix))?.prefix

  let prefix: string = ""
  let number: number | null = null

  if (countryPrefix) {
    prefix = countryPrefix

    const sub = parseInt(phone.substring(countryPrefix.length), 10)

    if (!isNaN(sub)) {
      number = sub
    }
  }

  return { prefix, number }
}
